/**
 * Collection Tabs PDP: ordenar productos por precio (mayor a menor) dentro de cada tab.
 * Ocultar Tab 1 "Mismo color" cuando no hay productos (respaldo al render Liquid).
 */
(function () {
  function hideEmptyTab1(section) {
    if (!section) return;

    var tab1Count = parseInt(section.getAttribute('data-tab1-count'), 10);
    if (isNaN(tab1Count)) {
      var grid = section.querySelector('.products.carousel');
      if (grid) {
        tab1Count = grid.querySelectorAll('[data-collection="tab-1"]').length;
      } else {
        tab1Count = 0;
      }
    }

    if (tab1Count > 0) return;

    section.classList.add('collection-tabs-pdp--tab1-empty');

    var tab1Btn = section.querySelector('button[data-collection="tab-1"]');
    var tab2Btn = section.querySelector('button[data-collection="tab-2"]');
    if (tab1Btn) tab1Btn.style.display = 'none';

    var grid = section.querySelector('.products.carousel');
    if (grid) {
      grid.querySelectorAll('[data-collection="tab-1"]').forEach(function (el) {
        el.classList.remove('carousel__slide');
      });
      grid.querySelectorAll('[data-collection="tab-2"]').forEach(function (el) {
        el.classList.add('carousel__slide');
      });
    }

    if (tab1Btn) tab1Btn.classList.remove('active');
    if (tab2Btn) {
      tab2Btn.classList.add('active');
      function activateTab2() {
        if (tab2Btn) tab2Btn.click();
      }
      if (customElements.get('collection-tabs')) {
        setTimeout(activateTab2, 0);
      } else if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('collection-tabs').then(function () {
          setTimeout(activateTab2, 0);
        });
      }
    }
  }

  function sortCollectionTabsPdpByPrice() {
    var sections = document.querySelectorAll('.collection-tabs-pdp');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var grid = section.querySelector('.products.carousel');
      if (!grid) return;

      var products = Array.from(grid.querySelectorAll('.collection-tabs--product[data-collection][data-price]'));
      var byTab = {};
      products.forEach(function (el) {
        var tab = el.getAttribute('data-collection');
        if (!byTab[tab]) byTab[tab] = [];
        byTab[tab].push(el);
      });

      if (products.length > 0) {
        ['tab-1', 'tab-2'].forEach(function (tab) {
          var list = byTab[tab];
          if (!list || list.length === 0) return;
          list.sort(function (a, b) {
            var priceA = parseInt(a.getAttribute('data-price'), 10) || 0;
            var priceB = parseInt(b.getAttribute('data-price'), 10) || 0;
            return priceB - priceA;
          });
        });
        var fragment = document.createDocumentFragment();
        ['tab-1', 'tab-2'].forEach(function (tab) {
          var list = byTab[tab];
          if (list) list.forEach(function (el) { fragment.appendChild(el); });
        });
        grid.appendChild(fragment);
      }

      hideEmptyTab1(section);

      var themeScroll = section.querySelector('theme-scroll');
      if (themeScroll && typeof themeScroll.init === 'function') {
        themeScroll.init();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortCollectionTabsPdpByPrice);
  } else {
    sortCollectionTabsPdpByPrice();
  }
})();
